
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateProjectShareSessionDtoFormGroup() {
return new FormGroup({
    token: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(64), Validators.minLength(1)]),
    pin: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(4), Validators.minLength(4), Validators.pattern(new RegExp("^[0-9]{4}$", ""))]),
})
;
}
      